import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import HeroResults from 'presentation/components/organisms/HeroResults';
import Results from 'presentation/components/organisms/Results';
import NotResults from 'presentation/components/organisms/NotResults';
import { searchRecording } from 'domain/services/recordings.service';
import { MutatingDots } from 'react-loader-spinner';

function Meeting() {
  const [loading, setLoading] = useState(true);
  const [serviceData, setServiceData] = useState();
  const { meetingId } = useParams();

  useEffect(() => {
    searchRecording(meetingId, setLoading).then((res) => {
      setServiceData(res.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className='max-w-screen-xl mt-24 px-8 xl:px-16 mx-auto h-full'>
      {loading ? (
        <div className='bg-gradient-to-b from-white-300 to-white-500 w-full py-14'>
          <div className='max-w-screen-xl  px-6 sm:px-8 lg:px-16 mx-auto flex flex-col w-full text-center justify-center'>
            <div className='flex flex-col w-full'>
              <h3 className='text-2xl sm:text-3xl lg:text-4xl font-medium text-black-600 leading-relaxed'>
                Estamos buscando grabaciones para esta Clase
              </h3>
              <div className='leading-normal w-10/12 sm:w-7/12 lg:w-6/12 mx-auto my-2 text-center'>
                <MutatingDots
                  color='#fff059'
                  secondaryColor='#fff059'
                  height='100'
                  width='110'
                  ariaLabel='loading-indicator'
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          {serviceData.status === 'success' ? (
            <>
              <HeroResults meeting={serviceData} />
              <Results meeting={serviceData} />
            </>
          ) : (
            <NotResults meeting={meetingId} />
          )}
        </div>
      )}
    </div>
  );
}

export default Meeting;
